import { ListAlt } from "@mui/icons-material";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import cx from 'classnames';
import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import SHQuickAction from "../../../../components/theme/Modal/SHQuickAction";
import Text from "../../../../components/theme/text/Text";
import ShCopyButton from "../../../../components/theme/ShCopy";
import { useGetWebshopProductsQuery } from "../../../../newapi/webshop/webshopSlice";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import { tokens } from "../../../../theme";
import UnmatchedProductCard from "../../../../components/global/cards/products/relation/UnmatchedProductCard";
import ShDataGrid3 from "../../../../components/theme/datagrid3/ShDataGrid3";

let gridOptions = {
    export: true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};

// const GridActions = (props) => {
//     const { t, i18n } = useTranslation();
//     const theme = useTheme();
//     const colors = tokens(theme.palette.mode);
//     return (
//         <ToggleButtonGroup
//             color={props.is_matched ? "green" : "red"}
//             value={props.is_matched}
//             exclusive
//             onChange={() => {
//                 if(props.is_matched === false) {
//                     props.setConfig(config => ({
//                         ...config,
//                         is_matched:null,
//                     }))
//                 } else {
//                     props.setConfig((config) => ({
//                         ...config,
//                         is_matched: false,
//                     }))
//                 }
//             }}
//             aria-label="Active"

//             className={cx(`${props.is_matched}`, {
//                 'active': props.is_matched === null
//             })}
//             sx={{
//                 background:colors.red[100],
//                 padding:0.5,
//                 borderRadius:5,
//                 transition:"250ms",
//                 "&.active" : {
//                     background: colors.grey[100],
//                     transition:"250ms",
//                 },
//             }}
//         >
//             <ToggleButton
//                 sx={{
//                     padding: 0,
//                     paddingX: 2,
//                     border: 0,
//                     lineHeight: "32px",
//                     textTransform: "unset",
//                     borderRadius: "32px !important",
//                     color:props.is_matched === null ?"#fff": colors.red[400],  // White text
//                     background: props.is_matched === null ? colors.grey[400] : "transparent", // Red background if inactive
//                     transition: "250ms",
//                     "&.Mui-selected": {
//                         background: colors.grey[400], 
//                         color: "#fff", 
//                         fontWeight:"bold",
//                     },
//                     "&.Mui-selected:hover": {
//                         background:theme.palette.mode === "dark" ? colors.grey[600]: "#1F293D",
//                     },
//                 }}
//                 value={null}
//             >
//                 {t('all')}
//             </ToggleButton>
//             <ToggleButton
//                 sx={{
//                     padding: 0,
//                     paddingX: 2,
//                     border: 0,
//                     lineHeight: "32px",
//                     textTransform: "unset",
//                     borderRadius: "32px !important",
//                     color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], // White text
//                     background: props.is_matched === true ? colors.red[400] : "transparent", // Green background if active
//                     transition: "250ms",
//                     "&.Mui-selected": {
//                         background: colors.red[400], // Green background if selected
//                         color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] :  colors.txt["white"], // White text
//                         fontWeight:"bold",
//                     },
//                     "&.Mui-selected:hover": {
//                         background:theme.palette.mode === "dark" ? "#F96462" : "#FF0F46"
//                     },
//                 }}
//                 value={false}
//             >
//                 {t('unmatched')}
//                 {/* {props.selectedWorkSpace.name} */}
//             </ToggleButton>
//         </ToggleButtonGroup>
//     )
// }
const UnmatchedProducts = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [config, setConfig] = useState({
        is_matched: false,
    });


    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
            
        }
    }, []);

    const columns = [
        {
            field: "sku",
            headerName: t('sku'),
            flex: 1,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        whiteSpace: "nowrap",
                        wordBreak: "keep-all",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        ".copyel": {
                            opacity: 0,
                        },
                        "&:hover .copyel": {
                            opacity: 1,
                        }
                    }}>
                        {!params.row.is_matched && 
                            <SHQuickAction
                                component={ 
                                    <Box
                                        sx={{
                                            px:1.5,
                                            display:"flex",
                                            flexDirection:"column"
                                        }}
                                    >
                                        <Text bold>{t("cant_match_product")}</Text>
                                    </Box>
                                }
                            >
                                {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                    <Box
                                    aria-owns={anchorEl ? "simple-popover" : undefined}
                                    aria-haspopup="true"
                                    onMouseEnter={ onMouseEnter }
                                    onMouseLeave={onMouseLeave}
                                    onTouchStart={onTouchStart}
                                        sx={{
                                            flexShrink:0,
                                            height:32,
                                            width:32,
                                            background:colors.red[400],
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent:'center',
                                            borderRadius:5,
                                            mr:1.5,
                                            color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"] 
                                        }}
                                    >
                                        <PriorityHighIcon/>
                                    </Box>
                                )}
                            </SHQuickAction>
                        }
                        <Text noBreak>{params.row.sku}</Text>
                        <ShCopyButton
                            styles={{button: {
                                background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover": {
                                    background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[300],
                                }
                            }}} 
                            sx={{position: "absolute", right: 0, zIndex: 3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.sku}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },

        {
            field: "description", 
            headerName: t("description"), 
            flex: 3,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Text noBreak>{params.row.description || '-'}</Text>
                );
            }
        },
        {
            field: "barcodes", 
            headerName: t("barcodes"), 
            flex: 2,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                const barcodes = params.row.barcodes || [];
                const displayText = barcodes.length === 1 ? `1 ${t('barcode')}` : `${barcodes.length} ${t('barcodes')}`;

                if(!params.row.is_matched) {
                    return (
                        <Text bold variant="red">-</Text>
                    )
                }
                return (
                    <SHQuickAction
                        component={ 
                            <Box
                                sx={{
                                    px:1.5,
                                    display:"flex",
                                    flexDirection:"column"
                                }}
                            >
                                <Text light>{t("barcodes")}</Text>
                                <Text>
                                    {barcodes.map((barcode, index) => (<>
                                        <Text key={index}>{barcode}</Text>
                                        <br/>
                                        </>
                                    ))}
                                </Text>
                            </Box>
                        }
                    >
                        {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                            <Box
                            aria-owns={anchorEl ? "simple-popover" : undefined}
                            aria-haspopup="true"
                            onMouseEnter={ onMouseEnter }
                            onMouseLeave={onMouseLeave}
                            onTouchStart={onTouchStart}
                            sx={{
                              px: 1.5,
                              height:32,
                              my: 0.5,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              cursor: "pointer",
                              gap: 3,
                              borderRadius: 12,
                              "&:hover": {
                                background: params.row.is_matched? colors.grey[50] : null,
                              },
                            }}
                          >
                             <ListAlt/>
                             <Text>{displayText}</Text>
                             </Box>
                        )}
                    </SHQuickAction>
                );
            }
        },
        {
            field: "total_quantity", 
            headerName: t("total_quantity"), 
            flex: 1,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if(!params.row.is_matched) {
                    return (
                        <Text bold variant="red">-</Text>
                    )
                }
                return (
                    <Text noBreak>{params.row.total_quantity || 0}</Text>
                );
            }
        },
        {
            field: "total_available", 
            headerName: t("available"), 
            flex: 1,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if(!params.row.is_matched) {
                    return (
                        <Text bold variant="red">-</Text>
                    )
                }
                return (
                    <Text noBreak>{params.row.total_available || 0}</Text>
                );
            }
        },
        {
            field: "productReference", 
            headerName: t("reference"), 
            flex: 1,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        whiteSpace: "nowrap",
                        wordBreak: "keep-all",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        ".copyel": {
                            opacity: 0,
                        },
                        "&:hover .copyel": {
                            opacity: 1,
                        }
                    }}>
                        <Text>{params.row.webshop_description}</Text>
                        <Text noBreak>{params.row.productReference || '-'}</Text>
                        {params.row.productReference && (
                            <ShCopyButton 
                                styles={{button: {
                                    background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[200],
                                    color: colors.txt["primary"],
                                    "&:hover": {
                                        background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[300],
                                    }
                                }}} 
                                sx={{position: "absolute", right: 0, zIndex: 3000}} 
                                className={"copyel"} 
                                closeAfter={1500} 
                                value={params.row.productReference}
                            ></ShCopyButton>
                        )}
                    </Box>
                );
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <UnmatchedProductCard 
                        skeleton={params.row.skeleton}
                        {...params.row}
                    />
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid3
                key={`${theme.palette.mode}`}
                gridKey="relations.products.unmatched"
                itemId={null}
                content={useGetWebshopProductsQuery}
                config={config}
                title={t('unmatched_products')}
                gridOptions={gridOptions}
                columns={columns}
                rows={data}
                sortModel={{field: columns[0].field, type: "DESC"}}
                getRowClassName={({ row }) => {
                    if (row.is_matched === false) return "error";
                }}
            >
            </ShDataGrid3>
        </Box>
    );
}

export default UnmatchedProducts; 